var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEbayFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-Ebay",
    transform: "translate(-24 -332)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(24 332)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ebay-logo",
    transform: "translate(25 311.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M20.816,30.788,18.944,34.2l-1.876-3.411H15.761l.334.569a2.576,2.576,0,0,0-2.113-.751c-2.334,0-2.484,1.16-2.484,1.345H12.66s.061-.677,1.242-.677c.768,0,1.363.319,1.363.932v.218H13.9c-1.51,0-2.425.335-2.686,1.013a2.615,2.615,0,0,0,.042-.467,2.367,2.367,0,0,0-2.6-2.35,2.3,2.3,0,0,0-2.006.75V28.861H5.529v3.818c-.016-.83-.61-2.073-2.684-2.073-1.552,0-2.845.6-2.845,2.4,0,1.428.87,2.327,2.885,2.327,2.372,0,2.524-1.418,2.524-1.418H4.26s-.246.764-1.445.764a1.514,1.514,0,0,1-1.678-1.437H5.529v1.187c0,.316-.025.76-.025.76H6.6a5.808,5.808,0,0,0,.039-.61,2.428,2.428,0,0,0,2.014.769,2.444,2.444,0,0,0,2.494-1.628,1.406,1.406,0,0,0-.01.16c0,.959.883,1.481,2.078,1.481a2.479,2.479,0,0,0,2.151-.816c0,.324.028.644.028.644h1.033s-.04-.4-.04-.65V32.346a1.769,1.769,0,0,0-.148-.744l2.093,3.566-.984,1.693H18.59L22,30.788ZM1.162,32.57c0-.822.827-1.291,1.643-1.291.929,0,1.563.517,1.563,1.291ZM8.38,34.659a1.676,1.676,0,1,1-.008-3.35A1.613,1.613,0,0,1,10.1,32.97,1.651,1.651,0,0,1,8.38,34.659Zm6.884-1.289c0,.379-.258,1.323-1.776,1.323-.832,0-1.188-.376-1.188-.814,0-.8,1.2-.8,2.965-.8v.291Z",
    transform: "translate(0 0)",
    fill: "#ba43b1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEbayFill);
export default __webpack_public_path__ + "static/media/icon-ebay-fill.3c2c0b79803f3a53f17cbc8d82dd41dc.svg";
export { ForwardRef as ReactComponent };